import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface DetectionResult {
  disease: string;
  confidence: number;
  description: string;
  treatment: string[];
  preventionMeasures: string[];
  imageUrl?: string;
}

export const pestDetectionService = {
  async detectDisease(imageFile: File): Promise<DetectionResult> {
    if (!API_URL) {
      throw new Error('Pest detection backend is not configured (VITE_API_URL is missing).');
    }
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await axios.post(`${API_URL}/pest-detection/analyze`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error detecting disease:', error);
      throw error;
    }
  },

  async getDiseaseInfo(diseaseName: string): Promise<DetectionResult> {
    if (!API_URL) {
      throw new Error('Pest detection backend is not configured (VITE_API_URL is missing).');
    }
    try {
      const response = await axios.get(`${API_URL}/pest-detection/disease/${diseaseName}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching disease info for ${diseaseName}:`, error);
      throw error;
    }
  }
};
